import { GALLERY_FADE_DURATION, GALLERY_SCALE_DURATION, TYPES } from '../const'
import Img from './Img'
import TWEEN, { Easing } from '@tweenjs/tween.js'
import shuffle from 'shuffle-array'

export default class Slides extends Img {
	protected readonly type = TYPES.SLIDES

	private readonly imgNodes: HTMLImageElement[]
	private scaleTween: any
	private changeTween: any
	private index = 0
	private oldIndex = 0
	private imgFade = -1
	private imgScale = 1
	private needsImageUpdate = true
	private textures: [WebGLTexture, WebGLTexture]
	private imgFadeLocation: WebGLUniformLocation
	private imgScaleLocation: WebGLUniformLocation
	private texture1Location: WebGLUniformLocation
	private texture2Location: WebGLUniformLocation

	constructor(params) {
		super(params)
		this.changeImage = this.changeImage.bind(this)

		this.imgNodes = params.nodes
		shuffle(this.imgNodes)
	}

	init(gl, program) {
		super.init(gl, program)

		this.textures = [this.getTexture(gl), this.getTexture(gl)]

		this.imgFadeLocation = gl.getUniformLocation(program, 'u_img_fade')
		this.imgScaleLocation = gl.getUniformLocation(program, 'u_img_scale')
		this.texture1Location = gl.getUniformLocation(program, 'u_texture_1')
		this.texture2Location = gl.getUniformLocation(program, 'u_texture_2')
	}

	async scaleImage() {
		if (this.scaleTween) this.scaleTween.stop()

		this.scaleTween = new TWEEN.Tween({ scale: 1 })
			.easing(Easing.Sinusoidal.InOut)
			.to({ scale: 0.95 }, GALLERY_SCALE_DURATION)
			.onUpdate(({ scale }) => (this.imgScale = scale))
			.onComplete(this.changeImage)
			.start()
	}

	async changeImage() {
		if (this.changeTween) this.changeTween.stop()

		this.oldIndex = this.index
		this.index = this.index + 1 < this.imgNodes.length ? this.index + 1 : 0

		this.imgFade = 0
		this.changeTween = new TWEEN.Tween({ fade: 0 })
			.to({ fade: 1 }, GALLERY_FADE_DURATION)
			.onUpdate(({ fade }) => (this.imgFade = fade))
			.onComplete(() => (this.imgFade = -1))
			.start()

		this.needsImageUpdate = true
		this.scaleImage()
	}

	async animateIn(forward) {
		await super.animateIn(forward)
		this.scaleImage()
	}

	async animateOut(forward) {
		if (this.scaleTween) this.scaleTween.stop()
		if (this.changeTween) this.changeTween.stop()
		await super.animateOut(forward)
		this.imgScale = 1
	}

	async preload(gl?) {
		await Promise.all(this.imgNodes.map((node) => this.loadImgNode(node)))
		this.baseAspect = this.imgNodes[0].naturalWidth / this.imgNodes[0].naturalHeight
	}

	draw(gl) {
		if (!this.visible) return

		gl.useProgram(this.program)

		if (this.needsImageUpdate) {
			this.needsImageUpdate = false

			gl.bindTexture(gl.TEXTURE_2D, this.textures[0])
			gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, this.imgNodes[this.oldIndex])

			gl.bindTexture(gl.TEXTURE_2D, this.textures[1])
			gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, this.imgNodes[this.index])
		}

		gl.uniform1i(this.texture1Location, 0)
		gl.uniform1i(this.texture2Location, 1)

		gl.activeTexture(gl.TEXTURE0)
		gl.bindTexture(gl.TEXTURE_2D, this.textures[0])
		gl.activeTexture(gl.TEXTURE1)
		gl.bindTexture(gl.TEXTURE_2D, this.textures[1])

		super.setAttributesAndUniforms(gl)

		gl.uniform1f(this.imgFadeLocation, this.imgFade)
		gl.uniform1f(this.imgScaleLocation, this.imgScale)
		gl.drawArrays(gl.TRIANGLES, 0, this.len)
	}
}
